import React, { useEffect, useRef, useState } from 'react';
import { Palette, Check } from 'lucide-react';
import useThemeStore, { PALETTES } from '../../store/themeStore';

export const PalettePicker = () => {
  const palette = useThemeStore((s) => s.palette || 'defaut');
  const setPalette = useThemeStore((s) => s.setPalette);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="text-[9px] px-2 py-0.5 rounded-sm bg-ink-700 text-slate-300 hover:text-foreground hover:bg-ink-600 transition-colors flex items-center gap-1 font-mono font-semibold uppercase tracking-wider border border-ink-600"
        data-testid="palette-toggle"
        title="Palette de couleurs"
      >
        <Palette className="w-2.5 h-2.5" />
        PAL
      </button>
      {open && (
        <div
          className="absolute left-0 top-full mt-1 z-[80] w-56 rounded-md border border-ink-600 bg-ink-800 shadow-xl p-1"
          data-testid="palette-menu"
        >
          <div className="px-2 py-1 text-[9px] uppercase tracking-wider text-slate-500 font-mono">Palette de couleurs</div>
          {PALETTES.map((p) => (
            <button
              key={p.id}
              onClick={() => { setPalette(p.id); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-sm text-left transition-colors hover:bg-ink-700 ${palette === p.id ? 'bg-ink-700' : ''}`}
              data-testid={`palette-option-${p.id}`}
            >
              <span className="flex gap-0.5 flex-shrink-0">
                {p.couleurs.map((c) => (
                  <span key={c} className="w-3 h-3 rounded-full border border-black/20" style={{ backgroundColor: c }} />
                ))}
              </span>
              <span className="flex flex-col min-w-0">
                <span className="text-[11px] font-semibold text-slate-200 leading-tight">{p.nom}</span>
                <span className="text-[9px] text-slate-500 leading-tight">{p.desc}</span>
              </span>
              {palette === p.id && <Check className="w-3 h-3 text-accent ml-auto flex-shrink-0" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
